import { render } from "./FinalSaleCompletion.vue?vue&type=template&id=44928993&ts=true"
import script from "./FinalSaleCompletion.vue?vue&type=script&lang=ts"
export * from "./FinalSaleCompletion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__